import { LogicContext } from '../types';
import { getCategory } from '../utils';

import Window from '../../../ports-frontend/Window';
import config from '../../../config';

export const getCategoriesLayoutContent = async (context: LogicContext) => {
  const {
    callbackMode,
    multiJackpots,
    currentJackpotsV2,
    currentTables,
    currentPersonalizedBanners,
    controllersData,
    user,
  } = context;
  const locale = config.locale;
  const currency = user?.currency || config.default_currency;
  const { loggedIn } = user;
  if (!controllersData?.categories) {
    return {
      updates: [],
    };
  }
  const windowInnerWidth = await Window.getInnerWidth();

  const updates = controllersData.categories!.components.map(([id, entry]) => ({
    type: 'setLayoutProperty',
    data: {
      path: `components.${id}.properties`,
      value: {
        category: getCategory({
          category: entry.properties,
          multiJackpots,
          currentJackpotsV2,
          currentTables,
          currentPersonalizedBanners,
          windowInnerWidth,
          currency,
          locale,
        }),
        currency,
        loggedIn,
        locale,
        callbackMode,
        visible: true,
        displayInMainSection: !!context.currentLayout?.components
          .SideNavigation,
      },
    },
  }));

  return {
    updates,
  };
};
